import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MessageThread } from "@ibetoni/messaging-ui";
import { useT } from "src/i18n";

// Shared chat-dialog shell for betonijerry's two message-thread popups
// (OfferCard customer chat + TarjouspyyntoDetail support chat). Renders the
// live MessageThread when a thread exists, otherwise `children` (e.g. a
// first-message composer that will create the thread). The flex title + close
// (X) match the hand-rolled idiom both dialogs previously duplicated.
export default function MessageThreadDialog({
    open, onClose, title, threadId, currentPersonId, token, apiBaseUrl,
    height = 420, maxWidth = "sm", children,
}) {
    const t = useT();
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth}>
            <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                {title}
                <IconButton onClick={onClose} size="small" aria-label={t("common.dialog.close")}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {threadId && currentPersonId ? (
                    <MessageThread
                        threadId={threadId}
                        currentPersonId={currentPersonId}
                        token={token}
                        apiBaseUrl={apiBaseUrl}
                        height={height}
                    />
                ) : children}
            </DialogContent>
        </Dialog>
    );
}
